import React, { PureComponent } from "react"
import { findIndex, map } from 'lodash-es'
import { formPagePath } from '../utilities/route'
import NavBar from "./navigation/nav-bar"
import NavMainAftergameLinks from './navigation/nav-main-aftergame-links'
import { Link } from "react-router-dom"
import IconHidden from "../images/icon-hidden.svg"
import "antd/lib/tree-select/style/css"
import StatisticsPageHero from './ui/statistics-page-hero'
import ThemeBadge from './ui/theme-badge'
import NavStatistics from './navigation/nav-statistics'
import Button from './ui/button'
import ParameterFilter from './ui/parameter-filter'
import { notEnoughRespondentsError } from '../utilities/helpers'
import { Survey } from '../utilities/Survey'
import RespondentGroups from './ui/respondent-groups'

class FinishPageDetails extends PureComponent {

  constructor(props) {
    super(props);
    const _surveyBeingEdited = sessionStorage.getItem("surveyBeingEdited") || false
    this.state = {
      surveyBeingEdited: !!(_surveyBeingEdited && _surveyBeingEdited === "true")
    };
  }

  t = (phrase) => {
    const { useTranslate } = this.props

    return useTranslate(`data_vault.${phrase}`)
  }

  handleFiltersChange = value => {
    this.props.onSetFilters(value);
  }

  renderOpenQuestion = (questionStats, index) => {
    const { title, catalystTitle, answers, respondentGroups } = questionStats;
    const {
      questionnaire: {
        catalysts
      }
    } = this.props;

    return (
      <div className="open-question" key={index}>
        <div className="open-question-header">
          <div className="mr-3 open-question-icon">?</div>
          <div>
            <h6>{title}</h6>
            <div className="theme-badges">
              <ThemeBadge
                themeTitle={catalystTitle}
                themeIndex={findIndex(catalysts, (c) => c.title === catalystTitle)}
              />
            </div>
          </div>
          {respondentGroups && <RespondentGroups items={respondentGroups} useTranslate={this.props.useTranslate} />}
        </div>
        <div className="open-question-body">
          {answers.map((answer, index) =>
            <div key={index} className={`open-question-answer ${answer.public ? '':'private'}`}>
              {answer.answer}
              {!answer.public &&
                <div className="private-indicator"><img src={IconHidden} alt="Hidden icon"/>{this.t("hidden_from_public")}</div>
              }
            </div>
          )}
        </div>
      </div>
    );
  };

  renderAnsweredOpenQuestions(questions) {
    const answered = questions.filter(q => q.answers.length > 0)
    return answered.length > 0
      ? <div style={{paddingBottom: "3rem"}}>{map(answered, this.renderOpenQuestion)}</div>
      : <p>{this.t("no_public_answers")}</p>
  }

  render() {
    const {
      match: {
        params: { surveyId, languageCode },
      },
      respondentParameters,
      afterGameDetailedOpenQuestionsStatistics,
      questionnaire,
      questionnaire: {
        canViewAfterGame,
        isAfterGameGuest,
        isFinished,
        canAnswer,
        logo,
        isDialogueActive,
        areProgressReportsActive
      },
      useTranslate,
      filters,
      improvementProject
    } = this.props;

    const toStatistics = formPagePath(languageCode, surveyId, 'finish', 'themes')
    const toEditAnswers = formPagePath(languageCode, surveyId)

    const title = (!canViewAfterGame && !isAfterGameGuest)
      ? useTranslate("survey_finished.your_statistics_page_title")
      : useTranslate("data_vault.statistics_page_title")

    const startEditingSurvey = () => {
      sessionStorage.setItem("surveyBeingEdited", "true");
      this.setState({surveyBeingEdited: true});
    }

    const isAfterGame = (canViewAfterGame || isAfterGameGuest)
    const notEnoughRespondents = afterGameDetailedOpenQuestionsStatistics.length > 0 &&
      afterGameDetailedOpenQuestionsStatistics[0].message === notEnoughRespondentsError;
    let questions
    if (!notEnoughRespondents) {
      const survey = new Survey(questionnaire.catalysts, respondentParameters)
      questions = afterGameDetailedOpenQuestionsStatistics.map(q => ({
          ...q,
          respondentGroups: isAfterGame ? survey.getRespondentGroups(q.id, 'open') : undefined
      }))
    } 

    return (
      <section className="finish-page">
        <StatisticsPageHero>
          <div className="aftergame-page-container">
            <NavBar
              to={isFinished && !canViewAfterGame && toStatistics}
              afterGame
              inverse={true}
              logo={logo}
              canViewAfterGame={canViewAfterGame}
              isAfterGameGuest={isAfterGameGuest}
            >
              {(canViewAfterGame || isAfterGameGuest) &&
                <NavMainAftergameLinks
                  activePage={"statistics"}
                  languageCode={languageCode}
                  surveyId={surveyId}
                  useTranslate={useTranslate}
                  isDialogueActive={isDialogueActive}
                  showProgressReports={areProgressReportsActive}
                  improvementProject={improvementProject}
                />
              }
            </NavBar>
          </div>
          <div className="aftergame-page-container">
            <div className="finish-page__intro">
              <h1>{title}</h1>
              { (!canViewAfterGame && !isAfterGameGuest) ?
                <div className="stats-description">
                  <p>{useTranslate("survey_finished.your_statistics_page_description")}</p>
                  { (isFinished && !canViewAfterGame && canAnswer) &&
                    <div>
                      <Button
                        as={Link}
                        to={toEditAnswers}
                        onClick={() => startEditingSurvey()}
                        size={"md"}
                      >
                        {this.t("edit_answers_button")}
                      </Button>
                    </div>
                  }
                </div>
                :
                <div className="stats-description">
                  <p>{useTranslate("data_vault.statistics_page_description")}</p>
                </div>
              }
              <div className="finish-page__intro__nav-holder">
                <NavStatistics
                  activePage={"open-questions"}
                  languageCode={languageCode}
                  surveyId={surveyId}
                  useTranslate={useTranslate}
                  questionnaire={questionnaire}
                />
              </div>
            </div>
          </div>
        </StatisticsPageHero>
        <div className="aftergame-page-container statistics-page-content finish-page__stats pb-5">
          <div className="finish-page__filters">
            {((canViewAfterGame || isAfterGameGuest) && respondentParameters.length > 0) && (
              <ParameterFilter
                filters={filters}
                handleFiltersChange={this.handleFiltersChange}
                respondentParameters={respondentParameters}
                isAfterGameGuest={isAfterGameGuest}
                useTranslate={useTranslate}
              />
            )}
          </div>
          <div className="open-questions">
            {!notEnoughRespondents && questions.length !== 0
              ? this.renderAnsweredOpenQuestions(questions)
            : (notEnoughRespondents &&
                <p>{this.t("no_results_for_parameter")}</p>
              )
            }
          </div>
        </div>
      </section>
    );
  }
}

export default FinishPageDetails



// WEBPACK FOOTER //
// ./src/components/statistics-page-openquestions.js